module.exports = __webpack_public_path__ + "static/media/WestpacPitch2@2x.524b82e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/outware/WestpacPitch2@2x.png
// module id = 160
// module chunks = 0